export function isReadOnlyWorkspace(draft) {
    return draft.workspaces[draft.workspace.current]?.source !== 'user';
}
